// extracted by mini-css-extract-plugin
export default {"title":"Confirm_title__aW0w7"};